import { Cargo } from "../models/Cargo";

export const MAP_DRIVER_FETCH_FAILED_MESSAGE =
  "获取货源详情失败，无法打开地图司机";
export const MAP_DRIVER_MISSING_COORDINATES_MESSAGE =
  "当前货源详情缺少始发地坐标，无法打开地图司机";

export type MapNavigationPayload = {
  lat: number;
  lon: number;
  address: string;
};

/**
 * 从货源始发地解析地图跳转所需的经纬度与地址文案。
 */
export const getMapNavigationPayload = (
  cargo: Cargo | null | undefined
): MapNavigationPayload | null => {
  const coordinates = cargo?.from?.location?.coordinates;
  const longitude = cargo?.from?.longitude;
  const latitude = cargo?.from?.latitude;

  const lon =
    Array.isArray(coordinates) && coordinates.length >= 2
      ? coordinates[0]
      : longitude;
  const lat =
    Array.isArray(coordinates) && coordinates.length >= 2
      ? coordinates[1]
      : latitude;

  if (typeof lat !== "number" || typeof lon !== "number") {
    return null;
  }

  const address = [
    cargo?.from?.province,
    cargo?.from?.city,
    cargo?.from?.district,
    cargo?.from?.address,
  ]
    .filter(Boolean)
    .join("");

  return {
    lat,
    lon,
    address,
  };
};

/**
 * 构造地图司机页路径（默认检索半径 50km，标注为发货地）。
 */
export const buildMapDriversPath = (
  payload: MapNavigationPayload,
  distance = 50
): string => {
  const searchParams = new URLSearchParams({
    lat: String(payload.lat),
    lon: String(payload.lon),
    address: payload.address,
    distance: String(distance),
    label: "发货地",
  });

  return `/map/map_drivers?${searchParams.toString()}`;
};
